import { combineReducers } from 'redux';

import update from './update';

export default combineReducers({ update });
